import { makeRequest } from 'utils/requestLogger';

export default (id, studentID) =>
  makeRequest(
    'get',
    `/api/courses/${id}/get_trending_online/${studentID}`
  ).then((res) => res.data);



// WEBPACK FOOTER //
// ./src/app/services/courses/fetchTrendingOnline.js